import { TolgeePlugin, FormatterMiddleware } from '@tolgee/core';

const createFormat = () => {
  const locales = new Map() as Map<string, string>;

  function isLocaleValid(locale: string) {
    try {
      return Boolean(Intl.NumberFormat.supportedLocalesOf(locale).length);
    } catch {
      return false;
    }
  }

  function getLocale(language: string) {
    if (!locales.get(language)) {
      let localeCandidate: string = String(language).replace(/[^a-zA-Z]/g, '-');
      while (!isLocaleValid(localeCandidate)) {
        localeCandidate = localeCandidate.split('-').slice(0, -1).join('-') || 'en';
      }
      locales.set(language, localeCandidate);
    }
    return locales.get(language);
  }

  const format: FormatterMiddleware['format'] = (props) => {
    const { translation } = props;
    return normalizeBraces(translation);
  };

  return Object.freeze({ getLocale, format });
};

function normalizeBraces(str: string): string {
  str = str.replace(/{{/g, '{');
  str = str.replace(/}}/g, '}');
  return str;
}

export const BraceFormat = (): TolgeePlugin => (tolgee, tools) => {
  tools.addFormatter(createFormat());
  return tolgee;
};
